import styled from 'styled-components';

import { css } from '@emotion/react';

export const SearchSelectContainerStyled = styled.div`
  min-width: 300px;
`;

export const SearchSelectCss = css({
  paddingLeft: '4px',
  backgroundColor: 'var(--ds-background-input, var(--ds-fb-background-input))',
});
